/**
 * Pre-configured NSwag API clients with authenticated fetch.
 * Use these instead of instantiating clients directly (e.g. new UsersClient()).
 */

import config from '../../config'
import { authenticatedFetch } from './httpClient'
import {
	AuditLogClient,
	CampaignClient,
	DataControllersClient,
	EmailLogClient,
	EmailTemplateClient,
	LicenseAdminClient,
	LicenseVClient,
	LicenseValidationClient,
	LocalizationClient,
	LookUpClient,
	MultiTenantClient,
	PlatformLookUpClient,
	PersonalClient,
	RolesClient,
	SettingsClient,
	SubscriptionClient,
	SubscriptionPlanAdminClient,
	SubscriptionQuoteClient,
	TokensClient,
	UsersClient,
} from './WebApiClient'

const baseUrl = config.LOCAL_API_URL || config.API_URL || 'https://localhost:7027'
const http = { fetch: authenticatedFetch }

// Singleton instances - clients are stateless, safe to reuse
export const auditLogClient = new AuditLogClient(baseUrl, http)
export const campaignClient = new CampaignClient(baseUrl, http)
export const dataControllersClient = new DataControllersClient(baseUrl, http)
export const emailLogClient = new EmailLogClient(baseUrl, http)
export const emailTemplateClient = new EmailTemplateClient(baseUrl, http)
export const licenseAdminClient = new LicenseAdminClient(baseUrl, http)
export const licenseValidationClient = new LicenseValidationClient(baseUrl, http)
export const licenseVClient = new LicenseVClient(baseUrl, http)
export const localizationClient = new LocalizationClient(baseUrl, http)
export const lookUpClient = new LookUpClient(baseUrl, http)
export const multiTenantClient = new MultiTenantClient(baseUrl, http)
export const platformLookUpClient = new PlatformLookUpClient(baseUrl, http)
export const personalClient = new PersonalClient(baseUrl, http)
export const rolesClient = new RolesClient(baseUrl, http)
export const settingsClient = new SettingsClient(baseUrl, http)
export const subscriptionClient = new SubscriptionClient(baseUrl, http)
export const subscriptionPlanAdminClient = new SubscriptionPlanAdminClient(baseUrl, http)
export const subscriptionQuoteClient = new SubscriptionQuoteClient(baseUrl, http)
export const tokensClient = new TokensClient(baseUrl, http)
export const usersClient = new UsersClient(baseUrl, http)
